import React, { useState } from 'react';
import './Puzzles.css';
import { Chessboard } from 'react-chessboard';

const Puzzles = ({ width }: { width: number }) => {

  const [position, setPosition] = useState('8/3P3k/n2K3p/2p3n1/1b4N1/2p1p1P1/8/3B4 w - - 0 1');

  const puzzleModes = [
    {
      title: "Puzzle Race",
      description: "Race against time to solve as many puzzles as possible. Test your speed and accuracy under pressure!",
      icon: "⚡",
      color: "from-red-500 to-orange-500",
      features: ["Time-based challenges", "Global leaderboards", "Speed training"]
    },
    {
      title: "Rated Puzzles",
      description: "Solve puzzles matched to your skill level. Improve your rating and track your progress over time.",
      icon: "🏆",
      color: "from-blue-500 to-purple-500",
      features: ["ELO-based rating", "Skill progression", "Personalized difficulty"]
    },
    {
      title: "Themed Puzzles",
      description: "Choose from various tactical themes like pins, forks, skewers, and more. Master specific patterns!",
      icon: "🎯",
      color: "from-green-500 to-teal-500",
      features: ["20+ tactical themes", "Pattern recognition", "Focused training"]
    }
  ];

  return (
    <section className="puzzles_container">
      <div className="puzzles_content">
        {/* Header Section */}
        <div className="puzzles_header">
          <h2 className="puzzles_title">
            Master Chess Tactics with Our
            <span className="puzzles_title_highlight"> Puzzle Collection</span>
          </h2>
          <p className="puzzles_subtitle">
            Sharpen your tactical skills with millions of carefully curated chess puzzles. 
            From beginner-friendly patterns to grandmaster-level combinations.
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="puzzles_grid">
          {/* Left Side - Puzzle Modes */}
          <div className="puzzles_modes">
            {puzzleModes.map((mode, index) => (
              <div key={index} className="puzzle_mode_card">
                <div className={`puzzle_mode_icon bg-gradient-to-r ${mode.color}`}>
                  <span>{mode.icon}</span>
                </div>
                <div className="puzzle_mode_content">
                  <h3 className="puzzle_mode_title">{mode.title}</h3>
                  <p className="puzzle_mode_description">{mode.description}</p>
                  <ul className="puzzle_mode_features">
                    {mode.features.map((feature, idx) => (
                      <li key={idx} className="puzzle_mode_feature">
                        <span className="feature_check">✓</span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          {/* Right Side - Puzzle Interface Preview */}
          <div className="puzzles_preview">
            <div className="puzzle_interface_mockup">
              {/* Header */}
              <div className="puzzle_header_mock">
                <div className="puzzle_info">
                  <span className="puzzle_rating">Rating: 2847</span>
                  <span className="puzzle_theme">Theme: Master</span>
                </div>
                <div className="puzzle_timer">
                  <span className="timer_icon">⏱️</span>
                  <span className="timer_text">02:34</span>
                </div>
              </div>
              <Chessboard 
              position={position}
              customBoardStyle={{ZIndex: 999999, marginBottom: '20px', borderRadius: "4px", boxShadow: "0 2px 10px rgba(0, 0, 0, 0.5)",}}
              />

              {/* Bottom Controls */}
              <div className="puzzle_controls_mock">
                <button className="control_btn hint_btn">
                  <span>💡</span>
                  Hint
                </button>
                <button className="control_btn solution_btn">
                  <span>🔍</span>
                  Show Solution
                </button>
                <button className="control_btn next_btn">
                  <span>⏭️</span>
                  Next Puzzle
                </button>
              </div>

              {/* Progress Bar */}
              <div className="puzzle_progress">
                <div className="progress_bar">
                  <div className="progress_fill" style={{ width: '67%' }}></div>
                </div>
                <span className="progress_text">Puzzle 67 of 100</span>
              </div>
            </div>

            {/* Stats Cards */}
            <div className="puzzle_stats">
              <div className="stat_card">
                <div className="stat_number">5,545</div>
                <div className="stat_label">Puzzles Solved</div>
              </div>
              <div className="stat_card">
                <div className="stat_number">89%</div>
                <div className="stat_label">Success Rate</div>
              </div>
              <div className="stat_card">
                <div className="stat_number">2,654</div>
                <div className="stat_label">Current Rating</div>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="puzzles_cta">
          <button className="puzzles_cta_button" onClick={() => window.open('https://analysis.chessmind.io/puzzles?mode=rated', '_blank')}>
            <span className="cta_icon">🧩</span>
            Start Solving Puzzles
            <span className="cta_arrow">→</span>
          </button>
          <p className="puzzles_cta_text">
            Join thousands of players improving their tactical vision every day
          </p>
        </div>
      </div>
    </section>
  );
};

export default Puzzles;
